const ROUTES = {
    DASHBOARD: '/app',
    FLK1: '/app/topics/flk1',
    FLK2: '/app/topics/flk2',
    PLANNER: '/app/planner',
    PROGRESS: '/app/progress',
    SETTINGS: '/app/settings',
    SRA: '/app/sra',
    MCQ: '/app/mcq',
    MCQ_SCRAPER: '/app/mcq/import',
    RECALL: '/app/recall',
    FEEDBACK: '/app/feedback',
    PRACTICE: '/app/practice',
    LOGIN: '/login',
    RESET_PASSWORD: '/reset-password',
    CHANGELOG: '/app/changelog',
    LAWDRILLS: '/app/lawdrills',
};

export default ROUTES;
